import { useEffect, useRef, useState, useCallback, useMemo } from "react";
import { conf } from "../../utils/config";
import useWebSocket, { ReadyState } from "react-use-websocket";
import { useSelector } from "react-redux";
import { doLoginThunk, selectStudent, setStudentPrioridad, setToken } from "../../reduxSlices/studentSlice";
import {
  clearUnsubProcessSectionIds,
  selectOfferedSubjects,
  setDetailSubjectOffered,
  setLoadingRequestInTransit,
  removeSubProcessSectionIds,
  setFailedProcessingSubject,
  removeFailedProcessingSubject,
  ISubjectQuotas,
  deleteUnsubProcessSectionId,
  removeSectionChangeInProcess,
  updateCuposValue,
  updateSingleCupoValue,
  removeFromInscribedSubjects,
  clearPanelSubjectsDataList,
  setInscribedSubjectsWithoutFilters,
  selectInscribedSubjectsWithoutFilters,
  removeVisibleOfferedSubject,
  ICuposValueSocket,
  updateSeccionOfertaValue,
  removeSeccionOferta,
  addCursoToUpdateQuota,
  removeCursoFromUpdateQuota,
  removePanelSubjectsData,
} from "../../reduxSlices/subjectsSlice";

import { SocketConfig, SocketState } from "../../SocketConfig";
import { isJsonString } from "../../utils";
import { websocketTypes } from "../../enums/websocket.enum";
import { removeSelectedOfferedSubject, setInscribedSubjects, setSubjectsQuota } from "../../reduxSlices/subjectsSlice";
import {
  useToastWarning,
  useToastError,
  useToastInfo,
  useToastSuccess,
  showToastErrorSoporte,
} from "../../hooks/useToast";
import { getMateriasInscriptasAlumno } from "../../Api/subject";
import { registrarRecepcionTx } from "../../Api/inscription";
import useMateriasAlumno from "../../hooks/useMateriasAlumno";
import {
  getCuposAlumnos,
  getCursoThunk,
  updateCupoCursoThunk,
} from "../../reduxAsyncThunks/subjects.thunks";
import store, { useAppDispatch } from "../../app/store";
import {
  selectOfertaInvalidandoOVenciendo,
  setInTransitInscriptionRequest,
  setLastUpdateOferta,
  setPanelFilters,
  setPanelSubjectInscribed,
} from "../../reduxSlices/globalFlagsSlice";
import { StorageKeys } from "../../utils/localStorage";
import { updatePrioridadThunk } from "../../reduxSlices/studentSlice";
import { dividirLista } from "../../utils/list";
import { v4 as uuid } from "uuid";
import moment from "moment";
import { useAuth } from "../../hooks/useAuth";
import { usePinnedSubjects } from "../../hooks/usePinnedSubjects";
import { filterInscribedSubjectsByParams } from "../../utils/inscribedSubjects";
import { IOfferedSubjectSection, IQuota } from "../../types";
import { CoreSeccionOferta } from "../../types/oferta";

// Cola optimizada para ACTUALIZACION_DE_CUPO
interface CupoUpdateQueue {
  quotaIds: Set<number>;
  processing: boolean;
  timeoutId: NodeJS.Timeout | null;
  metrics: {
    totalReceived: number;
    totalProcessed: number;
    totalDiscarded: number;
    lastUpdateTime: number;
  };
}

type MessageType =
  | "reservaResponse"
  | "cupoUpdate"
  | "desinscripcionOracleResponse"
  | "inscripcionOracleResponse"
  | "generacionKvOferta"
  | "generacionKvInscripcion"
  | "modoEdicionTimeout"
  | "cambioEstadoAlumno"
  | "cambioEstadoEdicionAlumno"
  | "logoutGeneral"
  | "logoutAlumno"
  | "cambioPrioridadAlumnos"
  | "warningMensaje"
  | "cuposReload"
  | "cambiosEnOferta"
  | "cambioPrioridad"
  | "carrerasReload"
  | "cupoValues"
  | "cupoValuesComplete"
  | "cambioSeccionOfertaValue"
  | "limpiarCacheCatalogo";

interface ICupoCompleteValue {
  idCupo: number;
  idCurso: number;
  anioLectivo: number;
  cantidad: number;
  semaforo: number;
}

interface WebSocketMessageDataJson {
  cupoId?: number;
  cupoValue?: ICuposValueSocket;
  cupoOptativo?: ICupoCompleteValue;
  cupoObligatorio?: ICupoCompleteValue;
  cursoId?: number;
  anioLectivo?: number;
  personaId?: number;
  estado?: number;
  idTx?: number;
  alumnosProgramasIds?: number[];
  personasIds?: number[];
  updateCupos?: boolean;
  solicitarCupo?: boolean;
  quotas?: {
    idCurso: number;
    idCupo: number;
    cantidad: number;
    semaforo: number;
  }[];
  idAlumnoPrograma?: number;
  seccionOfertaValue?: CoreSeccionOferta;
  cursosBorrados?: {
    idMateria: number;
    idCurso: number;
    anioLectivo: number;
  }[];
}

interface WebSocketMessage {
  id?: string;
  code: number;
  message: string;
  dataJson: WebSocketMessageDataJson;
  type: MessageType | string;
}

export interface DataJson {
  alumnosProgramasIds?: number[];
  personaId?: number;
  cursoId?: number;
  anioLectivo?: number;
  cupoId?: number;
  updateCupos?: boolean;
  cupoValue?: ICuposValueSocket;
  tipoMateria?: "OBLIGATORIO" | "OPTATIVO";
}

const checkIfQuotaExist = (subjectsQuotas: ISubjectQuotas, cupoId: number): IQuota | null => {
  try {
    const quota = subjectsQuotas[cupoId];
    return quota || null;
  } catch (error) {
    return null;
  }
};

const checkIfSectionExist = (subjectsQuotas: ISubjectQuotas, cursoId: number) => {
  const cuposQuotas = Object.values(subjectsQuotas);
  const existCurso = cuposQuotas.some((cupoQuota) => cupoQuota.cursoId === cursoId);
  return existCurso;
};

/** Refetch tras reconexión: como máximo estas veces dentro de la ventana. */
const REFRESH_TRAS_RECONEXION_MAX = 2;
const REFRESH_TRAS_RECONEXION_VENTANA_MS = 60_000;

const READY_STATE_LOG_STYLES: Record<number, { color: string; background: string }> = {
  [ReadyState.UNINSTANTIATED]: { color: "#374151", background: "#E5E7EB" },
  [ReadyState.CONNECTING]: { color: "#854D0E", background: "#FEF3C7" },
  [ReadyState.OPEN]: { color: "#166534", background: "#D1FAE5" },
  [ReadyState.CLOSING]: { color: "#9A3412", background: "#FFEDD5" },
  [ReadyState.CLOSED]: { color: "#991B1B", background: "#FEE2E2" },
};

const TX_RECEPCION_SOCKET_TYPES = new Set([
  websocketTypes.RESPUESTA_RESERVA,
  websocketTypes.RESPUESTA_INSCRIPCION_ORACLE,
  websocketTypes.RESPUESTA_DESINSCRIPCION_ORACLE,
]);

const ackRecepcionTransaccion = (socketMsg: WebSocketMessage, studentId: number) => {
  const idTx = socketMsg.dataJson?.idTx;
  const personaId = socketMsg.dataJson?.personaId;
  if (!idTx || personaId !== studentId || !TX_RECEPCION_SOCKET_TYPES.has(socketMsg.type as string)) {
    return;
  }
  const idAlumnoPrograma = Number(localStorage.getItem("idAP"));
  if (!idAlumnoPrograma) {
    return;
  }
  const fechaRecepcion = new Date().toISOString();
  void registrarRecepcionTx(idAlumnoPrograma, idTx, fechaRecepcion).catch(() => undefined);
};

const getDeviceId = () => {
  const token = localStorage.getItem("token");
  if (token) {
    let deviceId = localStorage.getItem("UAID");
    if (!deviceId) {
      deviceId = uuid();
      localStorage.setItem("UAID", deviceId);
    }
    return deviceId;
  } else {
    const campusToken = localStorage.getItem("campusToken");
    localStorage.clear();
    if (campusToken) {
      localStorage.setItem("campusToken", campusToken);
    }
    return "X";
  }
};

export default function WebsocketManager() {
  const showError = useToastError();
  const showSuccess = useToastSuccess();
  const showWarning = useToastWarning();
  const showWarningRef = useRef(showWarning);
  showWarningRef.current = showWarning;
  const student = useSelector(selectStudent);
  const [idPersona, setIdPersona] = useState<null | number>(null);
  const reloadCarrerasInfo = useRef(false);
  const dispatch = useAppDispatch();
  const offeredSubjects = useSelector(selectOfferedSubjects);
  const inscribedSubjectsWithoutFilters = useSelector(selectInscribedSubjectsWithoutFilters);
  const lastOfferRequestDate = useRef<null | {
    date: moment.Moment;
    socketMessage: WebSocketMessage;
  }>(null);
  const { refreshPinnedSubjects } = usePinnedSubjects();

  // Hook para obtener y actualizar materias
  const { fetchAndUpdateMaterias } = useMateriasAlumno(student.id, {
    updateTags: false, // No actualizar tags en WebsocketManager (ya están actualizados)
    updatePinnedSubjects: false, // Se pide por llamada con actualizarFijadas
    updateLastUpdateTimestamp: false, // Se maneja manualmente según el contexto
    refreshPinnedSubjects,
  });

  const ofertaEnCurso = useRef(false);
  const cambiosIgnoradoContados = useRef(0);
  // Ref para acceder al studentId actual desde dentro de setInterval con deps vacías
  const studentIdRef = useRef(student.id);
  studentIdRef.current = student.id;
  const minutoEnMilisegundos = 60000;
  const minutosDeIntervaloDeChequeo = minutoEnMilisegundos * 0.5;
  const { doLogout } = useAuth();

  // Socket
  const socketUrl = conf("WS");
  const ua = getDeviceId();

  // Cola optimizada para ACTUALIZACION_DE_CUPO
  const cupoUpdateQueue = useRef<CupoUpdateQueue>({
    quotaIds: new Set(),
    processing: false,
    timeoutId: null,
    metrics: {
      totalReceived: 0,
      totalProcessed: 0,
      totalDiscarded: 0,
      lastUpdateTime: Date.now(),
    },
  });

  const { sendMessage, lastMessage, readyState } = useWebSocket(
    `${socketUrl}?idPersona=${idPersona}&ua=${ua}`,
    SocketConfig,
    !!student?.id && !!idPersona,
  );
  const webSocketReadyStateRef = useRef<number>(0);
  const hasBeenOpenRef = useRef(false);
  const conexionPerdidaRef = useRef(false);
  const refreshOfertaYCuposEnCursoRef = useRef(false);
  const refreshTrasReconexionTimestampsRef = useRef<number[]>([]);
  const refreshTrasReconexionTimerRef = useRef<number | null>(null);
  const sendMessageRef = useRef(sendMessage);
  sendMessageRef.current = sendMessage;

  // Método centralizado para iniciar una solicitud de oferta
  const iniciarSolicitudOferta = (socketMsg: WebSocketMessage) => {
    console.log("--> 🆗 Iniciando solicitud de oferta");
    ofertaEnCurso.current = true;
    lastOfferRequestDate.current = { date: moment(), socketMessage: socketMsg };
    cambiosIgnoradoContados.current = 0; // Resetear estado de cambios ignorado
    handleRegenerarOferta(socketMsg);
  };
  // Ref para evitar stale closure dentro de setInterval con deps vacías
  const iniciarSolicitudOfertaRef = useRef(iniciarSolicitudOferta);
  iniciarSolicitudOfertaRef.current = iniciarSolicitudOferta;

  // Método centralizado para finalizar una solicitud de oferta
  const finalizarSolicitudOferta = () => {
    console.log("--> ✅ Solicitud de oferta finalizada");
    ofertaEnCurso.current = false;
    lastOfferRequestDate.current = null;
  };

  // Procesamiento optimizado de actualizaciones de cupos
  const processCupoUpdates = useCallback(async () => {
    if (cupoUpdateQueue.current.processing || cupoUpdateQueue.current.quotaIds.size === 0) {
      return;
    }

    cupoUpdateQueue.current.processing = true;

    try {
      // Procesar todos los cupos disponibles, incluyendo los que lleguen durante el procesamiento
      let totalProcessed = 0;

      while (cupoUpdateQueue.current.quotaIds.size > 0) {
        // Crear una copia de los quotaIds antes de procesarlos
        const quotaIds = Array.from(cupoUpdateQueue.current.quotaIds);
        console.log(
          `%cProcesando ${quotaIds.length} actualizaciones de cupos en lote - ${quotaIds}`,
          "color: blue; font-weight: bold;",
        );

        // Limpiar la cola ANTES de procesar para evitar pérdida de datos
        cupoUpdateQueue.current.quotaIds.clear();

        // Procesar en lotes para evitar sobrecarga
        const batchSize = 5;
        const batches = [];

        for (let i = 0; i < quotaIds.length; i += batchSize) {
          batches.push(quotaIds.slice(i, i + batchSize));
        }

        for (const batch of batches) {
          await Promise.all(batch.map((quotaId) => dispatch(updateCupoCursoThunk(quotaId))));
          // Pequeña pausa entre lotes para no saturar
          if (batches.length > 1) {
            await new Promise((resolve) => setTimeout(resolve, 100));
          }
        }

        totalProcessed += quotaIds.length;
        console.log(`%c✅ ${quotaIds.length} cupos actualizados exitosamente`, "color: green; font-weight: bold;");
      }

      console.log(`%c🎯 Total procesado en esta ronda: ${totalProcessed} cupos`, "color: purple; font-weight: bold;");
      cupoUpdateQueue.current.metrics.totalProcessed += totalProcessed;
    } catch (error) {
      console.error("Error procesando actualizaciones de cupos:", error);
    } finally {
      cupoUpdateQueue.current.processing = false;
    }
  }, [dispatch]);

  // Función para mostrar métricas de cupos
  const logCupoMetrics = useCallback(() => {
    const metrics = cupoUpdateQueue.current.metrics;
    const efficiency =
      metrics.totalReceived > 0 ? ((metrics.totalProcessed / metrics.totalReceived) * 100).toFixed(1) : "0";
    console.log(
      `%c📊 Métricas Cupos: Recibidos: ${metrics.totalReceived} | Procesados: ${metrics.totalProcessed} | Descartados: ${metrics.totalDiscarded} | Eficiencia: ${efficiency}%`,
      "color: purple; font-weight: bold;",
    );
  }, []);

  // Método para manejar cupos duplicados
  const handleDuplicateCupo = useCallback(
    (quotaId: number, context: string = "") => {
      console.log(
        `Cupo ${quotaId} duplicado detectado${context ? ` (${context})` : ""} - re-solicitando en 1.5 segundos`,
      );
      // Programar re-solicitud en 1.5 segundos para cupos duplicados
      setTimeout(() => {
        console.log(
          `Re-solicitando cupo ${quotaId} después de mensaje socket duplicado${context ? ` (${context})` : ""}`,
        );
        dispatch(updateCupoCursoThunk(quotaId));
      }, 1000);
    },
    [dispatch],
  );

  // Función optimizada para manejar ACTUALIZACION_DE_CUPO
  const handleCupoUpdateOptimized = useCallback(
    (dataJson: DataJson) => {
      const cursoId = dataJson.cursoId as number;
      const anioLectivo = dataJson.anioLectivo as number;
      console.log(`handleCupoUpdateOptimized: ⏳ cursoId: ${cursoId} - cupoId: ${dataJson.cupoId}`);

      if (!dataJson || !dataJson.cupoId) {
        return;
      }

      const { subjectsQuotas, offeredSubjects } = store.getState().subjects;

      // Actualizar métricas
      cupoUpdateQueue.current.metrics.totalReceived++;
      cupoUpdateQueue.current.metrics.lastUpdateTime = Date.now();

      const quotaId = dataJson.cupoId;

      // Si el socket trae el valor del cupo, actualizar directamente sin fetch
      if (dataJson.cupoValue) {
        const cuotaExist = checkIfQuotaExist(subjectsQuotas, quotaId);
        if (
          cuotaExist &&
          (!cuotaExist.lastUpdateTimestamp || cuotaExist.lastUpdateTimestamp < dataJson.cupoValue.lastUpdateTimestamp)
        ) {
          const { tipoMateria } = dataJson;
          const curso = offeredSubjects?.find((s) =>
            s.sections.find((s) => s.idCurso === cursoId && s.anioLectivo === anioLectivo),
          );
          if (curso && tipoMateria) {
            console.log(`curso encontrado: ${curso.id} - tipoMateria: ${tipoMateria}`);
            if (curso.tipoMateria === tipoMateria) {
              dispatch(updateSingleCupoValue(dataJson.cupoValue));
              cupoUpdateQueue.current.metrics.totalProcessed++;
              console.log(
                `%c✅ Cupo ${quotaId} - ${curso.tipoMateria} actualizado directamente desde socket | lastUpdateTimestamp: ${dataJson.cupoValue.lastUpdateTimestamp}`,
                "color: green; font-weight: bold;",
              );
            } else {
              console.log(`tipoMateria no coincide: ${curso.tipoMateria} !== ${tipoMateria}`);
              cupoUpdateQueue.current.metrics.totalDiscarded++;
            }
          } else {
            console.log(`curso no encontrado: ${cursoId} - anioLectivo: ${anioLectivo} - tipoMateria: ${tipoMateria}`);
            cupoUpdateQueue.current.metrics.totalDiscarded++;
          }
        } else {
          console.log(
            `%c❌ Cupo update ignored | quotaId: ${quotaId} | cuotaExist: ${!!cuotaExist} | cuotaExist: ${cuotaExist?.lastUpdateTimestamp} | cupoUpdateLastUpdateTimestamp: ${dataJson.cupoValue.lastUpdateTimestamp}`,
            "color: red; font-weight: bold;",
          );
          cupoUpdateQueue.current.metrics.totalDiscarded++;
        }
        return;
      }

      const cuotaExist = subjectsQuotas && checkIfQuotaExist(subjectsQuotas, quotaId);

      let updateBySection = false;
      if (!cuotaExist) {
        const sectionExist = checkIfSectionExist(subjectsQuotas, cursoId);
        if (sectionExist) {
          const cupoId = subjectsQuotas[quotaId]?.quotaId;
          if (cupoId && cupoId !== -1) {
            const isDuplicate = cupoUpdateQueue.current.quotaIds.has(cupoId);
            cupoUpdateQueue.current.quotaIds.add(cupoId);
            console.log(`Update by section: ${cursoId} - quotaId: ${cupoId}`);

            if (isDuplicate) {
              handleDuplicateCupo(quotaId, "by section");
            }

            updateBySection = true;
          } else {
            cupoUpdateQueue.current.metrics.totalDiscarded++;
            return;
          }
        } else {
          cupoUpdateQueue.current.metrics.totalDiscarded++;
          return;
        }
      }

      // Agregar a la cola de actualizaciones
      if (!updateBySection) {
        const isDuplicate = cupoUpdateQueue.current.quotaIds.has(quotaId);
        cupoUpdateQueue.current.quotaIds.add(quotaId);
        if (isDuplicate) {
          handleDuplicateCupo(quotaId);
        }
      }

      // Si ya hay un procesamiento en curso, no programar otro timeout
      if (cupoUpdateQueue.current.processing) {
        console.log(`Procesamiento ya en curso, cupo ${quotaId} agregado a la cola`);
        return;
      }

      // Limpiar timeout anterior si existe
      if (cupoUpdateQueue.current.timeoutId) {
        clearTimeout(cupoUpdateQueue.current.timeoutId);
      }

      // Programar procesamiento con debouncing (500ms)
      cupoUpdateQueue.current.timeoutId = setTimeout(() => {
        processCupoUpdates();
      }, 500);
    },
    [dispatch, processCupoUpdates, handleDuplicateCupo],
  );

  const toCupoValueSocket = (cupo: ICupoCompleteValue): ICuposValueSocket => ({
    idCupo: cupo.idCupo,
    idCurso: cupo.idCurso,
    anioLectivo: cupo.anioLectivo,
    cantidad: cupo.cantidad,
    semaforo: cupo.semaforo,
    error: false,
    errorMessage: "",
    lastUpdateTimestamp: Date.now(),
  });

  const handleCupoValuesComplete = useCallback(
    (socketMsg: WebSocketMessage) => {
      const { cursoId, anioLectivo, cupoOptativo, cupoObligatorio } = socketMsg.dataJson;

      if (!cursoId || !anioLectivo) {
        return;
      }

      const { offeredSubjects, subjectsQuotas } = store.getState().subjects;
      const curso = offeredSubjects?.find((s) =>
        s.sections.some((sec) => sec.idCurso === cursoId && sec.anioLectivo === anioLectivo),
      );

      if (!curso) {
        console.log(`cupoValuesComplete: curso no encontrado ${cursoId} - anioLectivo: ${anioLectivo}`);
        return;
      }

      const cupoData =
        curso.tipoMateria === "OPTATIVO" ? cupoOptativo : curso.tipoMateria === "OBLIGATORIO" ? cupoObligatorio : null;

      if (!cupoData) {
        console.log(`cupoValuesComplete: sin cupo para tipoMateria ${curso.tipoMateria}`);
        return;
      }

      const cuotaExist = checkIfQuotaExist(subjectsQuotas, cupoData.idCupo);
      if (!cuotaExist) {
        console.log(`cupoValuesComplete: cupo ${cupoData.idCupo} no existe en state`);
        return;
      }

      dispatch(updateSingleCupoValue(toCupoValueSocket(cupoData)));
      cupoUpdateQueue.current.metrics.totalProcessed++;
      console.log(
        `%c✅ Cupo ${cupoData.idCupo} - ${curso.tipoMateria} actualizado desde cupoValuesComplete`,
        "color: green; font-weight: bold;",
      );
    },
    [dispatch],
  );

  useEffect(() => {
    const interval = setInterval(() => chequearUltimaSolicitudDeOferta(), minutosDeIntervaloDeChequeo);
    const metricsInterval = setInterval(() => {
      if (cupoUpdateQueue.current.metrics.totalReceived > 0) {
        logCupoMetrics();
      }
    }, 30000); // Mostrar métricas cada 30 segundos

    return () => {
      clearInterval(interval);
      clearInterval(metricsInterval);
      // Limpiar timeout de cupo updates al desmontar
      if (cupoUpdateQueue.current.timeoutId) {
        clearTimeout(cupoUpdateQueue.current.timeoutId);
      }
    };
  }, [logCupoMetrics]);

  // Nuevo intervalo para limpiar ofertaEnCurso si se queda atascado
  useEffect(() => {
    const interval = setInterval(() => {
      const minutosDeTolerancia = 5;
      //console.log("-> Chequeando timeout de ofertaEnCurso... 🔍");

      if (
        ofertaEnCurso.current &&
        lastOfferRequestDate.current &&
        lastOfferRequestDate.current.date &&
        cambiosIgnoradoContados.current > 0
      ) {
        const diff = moment().diff(lastOfferRequestDate.current.date, "minutes");
        console.log(`Oferta en curso por ${diff} minutos`);

        if (diff >= minutosDeTolerancia) {
          console.log("--> 🚨 OFERTA SUPERÓ TIMEOUT - Limpiando estado y solicitando nueva oferta");

          const socket: WebSocketMessage = {
            code: 200,
            dataJson: { updateCupos: true, personaId: studentIdRef.current },
            message: "",
            type: "",
          };
          iniciarSolicitudOfertaRef.current(socket);
        }
      } else {
        //console.log("--> Check de ofertaEnCurso 🆗");
      }
    }, 60000); // 1 minuto

    return () => clearInterval(interval);
  }, []);

  const handleCambioPrioridadAlumnos = async (socketMsg: WebSocketMessage) => {
    const idAlumnoPrograma = localStorage.getItem("idAP");
    console.log("handleCambioPrioridadAlumnos");
    if (idAlumnoPrograma && socketMsg.dataJson?.alumnosProgramasIds?.includes(Number(idAlumnoPrograma))) {
      handleCambioPrioridad();
    }
  };

  const showWarningMessage = async (message: string) => {
    showWarning(message);
  };

  const handleCambioPrioridad = async () => {
    if (student.prioridad !== null) {
      const resultAction = await dispatch(updatePrioridadThunk(student.prioridad));

      // Verificar si se agotaron los reintentos
      if (updatePrioridadThunk.rejected.match(resultAction)) {
        const errorPayload = resultAction.payload;
        if (errorPayload === "REINTENTOS_AGOTADOS") {
          showWarning(
            "No se pudo obtener la información de prioridad después de varios intentos. La página se refrescará automáticamente.",
          );
          setTimeout(() => {
            window.location.reload();
          }, 3500);
        }
      }
    }
  };

  const refreshEventsSocketLost = useCallback(async () => {
    if (refreshOfertaYCuposEnCursoRef.current) return;
    if (!localStorage.getItem("idAP") || !student.id) return;
    if (!store.getState().subjects.offeredSubjects?.length) return;
    if (document.visibilityState !== "visible" || webSocketReadyStateRef.current !== ReadyState.OPEN) {
      conexionPerdidaRef.current = true;
      return;
    }

    const now = Date.now();
    const recientes = refreshTrasReconexionTimestampsRef.current.filter(
      (ts) => now - ts < REFRESH_TRAS_RECONEXION_VENTANA_MS,
    );
    refreshTrasReconexionTimestampsRef.current = recientes;

    if (recientes.length >= REFRESH_TRAS_RECONEXION_MAX) {
      if (refreshTrasReconexionTimerRef.current != null) return;
      const espera = Math.max(0, REFRESH_TRAS_RECONEXION_VENTANA_MS - (now - recientes[0]));
      console.log(
        `%cRefresh tras reconexión limitado (${REFRESH_TRAS_RECONEXION_MAX} cada ${REFRESH_TRAS_RECONEXION_VENTANA_MS / 1000}s). Reintento en ${Math.ceil(espera / 1000)}s`,
        "color: #854D0E; background: #FEF3C7; padding: 2px 8px;",
      );
      refreshTrasReconexionTimerRef.current = window.setTimeout(() => {
        refreshTrasReconexionTimerRef.current = null;
        void refreshEventsSocketLostRef.current();
      }, espera);
      return;
    }

    refreshTrasReconexionTimestampsRef.current.push(now);
    refreshOfertaYCuposEnCursoRef.current = true;
    console.log(
      "%cRefetch prioridad, inscriptas, /materias y cupos tras pérdida de socket",
      "color: teal; text-decoration: underline;",
    );
    try {
      const resultAction = await dispatch(updatePrioridadThunk(store.getState().student.prioridad));
      if (updatePrioridadThunk.rejected.match(resultAction) && resultAction.payload === "REINTENTOS_AGOTADOS") {
        showWarningRef.current(
          "No se pudo obtener la información de prioridad después de varios intentos. La página se refrescará automáticamente.",
        );
        setTimeout(() => {
          window.location.reload();
        }, 3500);
        return;
      }

      const inscriptas = await getMateriasInscriptasAlumno(student.id);
      if (inscriptas.status === 200 && inscriptas.data) {
        dispatch(setInscribedSubjectsWithoutFilters(inscriptas.data));
      }

      await fetchAndUpdateMaterias({ cupos: "completos" });
    } finally {
      refreshOfertaYCuposEnCursoRef.current = false;
    }
  }, [student.id, fetchAndUpdateMaterias, dispatch]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState !== "visible") return;
      if (!localStorage.getItem("idAP") || !student.id) return;
      if (!conexionPerdidaRef.current) return;
      if (webSocketReadyStateRef.current !== ReadyState.OPEN) return;

      conexionPerdidaRef.current = false;
      void refreshEventsSocketLost();
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [student.id, refreshEventsSocketLost]);

  useEffect(() => {
    return () => {
      if (refreshTrasReconexionTimerRef.current != null) {
        window.clearTimeout(refreshTrasReconexionTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (student.id) {
      setIdPersona(student.id);
      console.log("student.id:", student.id);
    }
  }, [student.id]);

  useEffect(() => {
    // Filtrar materias inscritas si tenemos oferta disponible
    if (offeredSubjects && inscribedSubjectsWithoutFilters) {
      const filteredSubjects = filterInscribedSubjectsByParams(inscribedSubjectsWithoutFilters, offeredSubjects);
      dispatch(setInscribedSubjects(filteredSubjects));
    }
  }, [offeredSubjects, inscribedSubjectsWithoutFilters]);

  const handleRegenerarOfertaEInscripciones = async (esOferta: boolean, socketMsg: WebSocketMessage) => {
    await dispatch(setInTransitInscriptionRequest(true)); // not use
    await dispatch(setDetailSubjectOffered(null)); // not use
    await dispatch(setPanelSubjectInscribed(false));
    await dispatch(setPanelFilters(false));
    const idAlumnoPrograma = localStorage.getItem("idAP");
    const debeActualizar =
      idAlumnoPrograma && socketMsg.dataJson.alumnosProgramasIds?.includes(Number(idAlumnoPrograma));
    /* ------------------------- regenerar inscripciones ------------------------ */
    if (!esOferta && debeActualizar) {
      const results = await getMateriasInscriptasAlumno(student.id);
      if (results.status === 200) {
        console.log("%cACTUALIZANDO MATERIAS INSCRIPTAS ⏳", "color: pink; text-decoration: underline;");

        // Filtrar materias inscritas si tenemos oferta disponible
        dispatch(setInscribedSubjectsWithoutFilters(results.data));

        console.log("%cMATERIAS INSCRIPTAS ACTUALIZADAS ✅", "color: green; text-decoration: underline;");
      }
      await dispatch(setLastUpdateOferta(new Date().getTime()));
    }
    /* ---------------------------- Regenerar oferta ---------------------------- */
    if (esOferta && debeActualizar) {
      console.log("cursos: obteniendo...");
      // La oferta arrastra los cupos: el hook los pide con la respuesta en mano,
      // después de refrescar las fijadas, que definen el split fijados/no fijados.
      console.log("%cACTUALIZANDO OFERTA x ACTUALIZACION_OFERTA_KV ⏳", "color: cyan; text-decoration: underline;");
      const result = await fetchAndUpdateMaterias({ cupos: "completos", actualizarFijadas: true });

      if (result.success) {
        console.log("%cOFERTA ACTUALIZADA ✅", "color: green; text-decoration: underline;");
        // Actualizar timestamp manualmente ya que el hook tiene updateLastUpdateTimestamp: false
        await dispatch(setLastUpdateOferta(new Date().getTime()));
      }
      /* ---------------------------- Actualiza carreras ---------------------------- */
      if (reloadCarrerasInfo.current) {
        setTimeout(() => {
          handleReloadCarreras();
          reloadCarrerasInfo.current = false;
        }, 5000);
      }
    }
    /* --------------------------------------------------------------------------- */
    finalizarSolicitudOferta();
  };

  /** CUPOS_RELOAD: pide cupos sin oferta nueva, sobre la que ya está en el store. */
  const updateCupos = async () => {
    dispatch(setPanelSubjectInscribed(false));
    dispatch(setPanelFilters(false));
    const { debeConsultarCupos } = store.getState().student;
    if (!debeConsultarCupos) {
      console.log("-> WS: Se omite update cupos porque backend indicó debeConsultarCupos=false");
    } else if (selectOfertaInvalidandoOVenciendo(store.getState())) {
      // Se piden al llegar generacionKvOferta, junto con la oferta regenerada.
      console.log("-> WS: Se omite update cupos porque la oferta se está regenerando");
    } else {
      console.log("%cWS ACTUALIZANDO CUPOS ⏳", "color: cyan; text-decoration: underline;");
      await dispatch(getCuposAlumnos({ idAlumno: student.id }));
    }
  };

  const handleRegenerarOferta = async (socketMsg: WebSocketMessage) => {
    /* ---------------------------- Regenerar oferta ---------------------------- */
    dispatch(setPanelSubjectInscribed(false));
    dispatch(setPanelFilters(false));
    console.log("%cACTUALIZANDO OFERTA x CAMBIOS_EN_OFERTA ⏳", "color: cyan; text-decoration: underline;");
    const result = await fetchAndUpdateMaterias({
      cupos: socketMsg.dataJson.updateCupos === false ? "ninguno" : "completos",
    });

    if (result.success) {
      console.log("%cOFERTA ACTUALIZADA ✅", "color: green; text-decoration: underline;");
    }
  };

  const chequearUltimaSolicitudDeOferta = () => {
    const segundosDeTolerancia = 30;
    //console.log("-> Chequeando ultima solicitud de oferta... 🔍");
    if (
      !ofertaEnCurso.current &&
      lastOfferRequestDate.current &&
      lastOfferRequestDate.current.date &&
      lastOfferRequestDate.current.socketMessage &&
      cambiosIgnoradoContados.current > 0
    ) {
      const diff = moment().diff(lastOfferRequestDate.current.date, "seconds");
      console.log(
        `Se ingnoraron ${cambiosIgnoradoContados.current} cambios de oferta desde la ultima solicitud de oferta`,
      );
      console.log("Segundos desde la ultima solicitud de oferta:", diff);
      if (diff >= segundosDeTolerancia) {
        console.log("--> 🆗 CAMBIO OFERTA No ignorado, solicitando nuevamente...");
        const socket: WebSocketMessage = {
          code: 200,
          dataJson: { updateCupos: true, personaId: student.id },
          message: "",
          type: "",
        };
        iniciarSolicitudOferta(socket);
      }
    } else {
      //console.log("--> Check útlima solicitud de oferta 🆗");
    }
  };

  const handleReloadCarreras = async () => {
    // El thunk centraliza la actualización de carreras, bloqueo, mostrarHorarios, etc.
    await dispatch(doLoginThunk({ email: student.email }));
  };

  const handleLimpiarCacheCatalogo = (socketMsg: WebSocketMessage) => {
    const { cursoId, anioLectivo } = socketMsg.dataJson;
    if (cursoId && anioLectivo) {
      dispatch(removePanelSubjectsData({ idCurso: cursoId, anioLectivo: anioLectivo }));
    }
  };

  const handleUpdateCursoOferta = (socketMsg: WebSocketMessage) => {
    const { subjects, globalFlags, student: alumno } = store.getState();
    const subjectsQuotas = subjects.subjectsQuotas;
    const detailPanelSubjectOffered = subjects.detailSubjectOffered;
    const cursosToUpdateQuotaList = subjects.cursosToUpdateQuotaList;
    const panelSubjectsDataList = subjects.panelSubjectsDataList;
    const { mobileFeatures, tabletDevice } = globalFlags;

    if (socketMsg.dataJson.seccionOfertaValue) {
      // ### SOCKET CON CURSO ACTUALIZADO ###
      const { anio_lectivo, id_curso, id_materia, data } = socketMsg.dataJson.seccionOfertaValue;
      const newSection = data as unknown as IOfferedSubjectSection;
      // Si el idCupo es -1 quitar curso de la oferta
      if (
        newSection.subjectData.reserveData?.idC === -1 &&
        alumno.prioridad &&
        alumno.debeFiltrarCursosConCupoNoAsignado
      ) {
        dispatch(removeSeccionOferta({ id_materia, id_curso, anio_lectivo }));
      } else {
        // Se evalua contra el state actual (no el del closure) para evitar resultados
        // stale cuando llegan varios mensajes WS consecutivos antes del re-render.
        const offeredSubjectsBefore = store.getState().subjects.offeredSubjects;
        const seccionExistiaPreviamente = !!offeredSubjectsBefore
          ?.find((s) => s.id === id_materia)
          ?.sections.some((sec) => sec.idCurso === id_curso && sec.anioLectivo === anio_lectivo);

        dispatch(updateSeccionOfertaValue(socketMsg.dataJson.seccionOfertaValue));
        // Actualizar el detalle del curso en panel lateral si es el mismo curso que se está actualizando
        if (
          detailPanelSubjectOffered &&
          detailPanelSubjectOffered.idCurso === id_curso &&
          detailPanelSubjectOffered.anioLectivo === anio_lectivo
        ) {
          dispatch(
            setDetailSubjectOffered({
              subjectId: socketMsg.dataJson.seccionOfertaValue.id_materia,
              cursoId: id_curso,
            }),
          );
        }

        const idCupo = socketMsg.dataJson?.seccionOfertaValue?.data?.subjectData?.reserveData?.idC;
        const pendingQuota = cursosToUpdateQuotaList.find(
          (item) => item.idCurso === id_curso && item.anioLectivo === anio_lectivo,
        );
        const debeConsultarCupoPorPrioridad = !!alumno.debeConsultarCupos;
        const cupoValido = idCupo && idCupo !== -1;
        const cupoYPrioridadValido = debeConsultarCupoPorPrioridad && cupoValido;

        let cupoUpdated = false;
        if (pendingQuota && cupoYPrioridadValido) {
          dispatch(updateCupoCursoThunk(idCupo));
          cupoUpdated = true;
          dispatch(removeCursoFromUpdateQuota({ idCurso: id_curso, anioLectivo: anio_lectivo }));
        } else {
          const existeCupo = checkIfQuotaExist(subjectsQuotas, idCupo);
          if (cupoYPrioridadValido && (!existeCupo || !seccionExistiaPreviamente)) {
            dispatch(updateCupoCursoThunk(idCupo));
            cupoUpdated = true;
          }
        }
        // En mobile o tablet siempre actualizar cupo post curso update
        if ((mobileFeatures || tabletDevice) && !cupoUpdated) {
          dispatch(updateCupoCursoThunk(idCupo));
        }
      }
      // Si el curso existe en la memoria de datos de catalogo y condicion de aprobacion, removerlo
      if (
        panelSubjectsDataList &&
        panelSubjectsDataList.find((item) => item.idCurso === id_curso && item.anioLectivo === anio_lectivo)
      ) {
        dispatch(removePanelSubjectsData({ idCurso: id_curso, anioLectivo: anio_lectivo }));
      }
    } else {
      // ### SOCKET PARA SOLICITAR REGENERACION DE CURSO ###
      const idCurso = socketMsg.dataJson.cursoId || 0;
      const anioLectivo = socketMsg.dataJson.anioLectivo || 0;
      dispatch(getCursoThunk({ idCurso, anioLectivo }));
      if (socketMsg.dataJson?.solicitarCupo) {
        dispatch(addCursoToUpdateQuota({ idCurso, anioLectivo }));
      }
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                CONECTADO WS                                */
  /* -------------------------------------------------------------------------- */
  const refreshEventsSocketLostRef = useRef(refreshEventsSocketLost);
  refreshEventsSocketLostRef.current = refreshEventsSocketLost;

  useEffect(() => {
    const { color, background } = READY_STATE_LOG_STYLES[readyState] ?? { color: "black", background: "yellow" };
    const stateLabel = SocketState.get(readyState) ?? ReadyState[readyState];
    console.log(
      `%c[${new Date().toLocaleTimeString()}] WS State : ${stateLabel}`,
      `color: ${color}; background: ${background}; padding: 2px 30px; border-radius: 4px; font-weight: bold;`,
    );
    webSocketReadyStateRef.current = readyState;

    if (readyState === ReadyState.OPEN) {
      sendMessageRef.current("Connection established");

      if (hasBeenOpenRef.current && conexionPerdidaRef.current && document.visibilityState === "visible") {
        conexionPerdidaRef.current = false;
        void refreshEventsSocketLostRef.current();
      }

      hasBeenOpenRef.current = true;
    } else if (hasBeenOpenRef.current) {
      conexionPerdidaRef.current = true;
    }
    // Solo readyState: sendMessage y el refresh se leen por ref.
    // Si entran al array, cada mensaje WS recrea el callback y reenvía "Connection established".
  }, [readyState]);

  /* -------------------------------------------------------------------------- */
  /*                             READING WS Messages                            */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    if (lastMessage && isJsonString(lastMessage.data)) {
      const socketMsg: WebSocketMessage = JSON.parse(lastMessage.data);
      ackRecepcionTransaccion(socketMsg, student.id);
      // console.log("zWS EN APP --->", socketMsg);
      console.log("EVENTO WS EN APP ---> Type: ", socketMsg.type);
      console.log(socketMsg);
      /* ---------------------------- IF socket NOT OK ---------------------------- */
      if (socketMsg.code !== 200 && socketMsg.dataJson) {
        const idPersona = socketMsg.dataJson.personaId;
        if (idPersona === student.id) {
          const errorSoporte = socketMsg.message.includes("De persistir el problema avisanos");
          if (errorSoporte) {
            showToastErrorSoporte();
          } else {
            showError(socketMsg.message);
          }
        }

        switch (socketMsg.type) {
          case websocketTypes.RESPUESTA_RESERVA:
            dispatch(
              setFailedProcessingSubject({
                idCurso: socketMsg.dataJson.cursoId || 0,
                anioLectivo: socketMsg.dataJson.anioLectivo || 0,
              }),
            );
            setTimeout(() => {
              dispatch(
                removeFailedProcessingSubject({
                  idCurso: socketMsg.dataJson.cursoId || 0,
                  anioLectivo: socketMsg.dataJson.anioLectivo || 0,
                }),
              );
            }, 3000);
            dispatch(
              removeSubProcessSectionIds({
                idCurso: socketMsg.dataJson.cursoId || 0,
                anioLectivo: socketMsg.dataJson.anioLectivo || 0,
              }),
            );
            dispatch(
              removeSectionChangeInProcess({
                idCurso: socketMsg.dataJson.cursoId || 0,
                anioLectivo: socketMsg.dataJson.anioLectivo || 0,
              }),
            );
            break;
          case websocketTypes.RESPUESTA_INSCRIPCION_ORACLE:
            if (socketMsg.dataJson.cursoId && socketMsg.dataJson.anioLectivo && socketMsg.code === 400) {
              // INSCRIPCION ORACLE ERROR
              dispatch(
                setFailedProcessingSubject({
                  idCurso: socketMsg.dataJson.cursoId || 0,
                  anioLectivo: socketMsg.dataJson.anioLectivo || 0,
                }),
              );
              dispatch(
                // remove sub process section ids
                removeSubProcessSectionIds({
                  idCurso: socketMsg.dataJson.cursoId || 0,
                  anioLectivo: socketMsg.dataJson.anioLectivo || 0,
                }),
              );
              setTimeout(() => {
                dispatch(
                  removeFailedProcessingSubject({
                    idCurso: socketMsg.dataJson.cursoId || 0,
                    anioLectivo: socketMsg.dataJson.anioLectivo || 0,
                  }),
                );
              }, 3000);
              // remove section change in process
              dispatch(
                removeSectionChangeInProcess({
                  idCurso: socketMsg.dataJson.cursoId || 0,
                  anioLectivo: socketMsg.dataJson.anioLectivo || 0,
                }),
              );
            }
            break;
          default:
            break;
        }

        dispatch(clearUnsubProcessSectionIds());
      }

      /* ----------------------------- IF socket is OK ---------------------------- */
      if (socketMsg.code === 200 && socketMsg.type) {
        const idPersona = socketMsg.dataJson.personaId;
        if (
          idPersona === student.id &&
          socketMsg?.message?.length > 0 &&
          socketMsg.type !== websocketTypes.WARNING_MENSAJE &&
          socketMsg.type !== websocketTypes.CAMBIO_SECCION_OFERTA_VALUE &&
          socketMsg.type !== websocketTypes.CURSOS_BORRADOS &&
          socketMsg.type !== websocketTypes.LIMPIAR_CACHE_CATALOGO
        ) {
          showSuccess(socketMsg.message);
        }
        switch (socketMsg.type) {
          case websocketTypes.LOGOUT_GENERAL:
            doLogout();
            break;
          case websocketTypes.CAMBIO_PRIORIDAD_ALUMNOS:
            handleCambioPrioridadAlumnos(socketMsg);
            break;
          case websocketTypes.WARNING_MENSAJE:
            showWarningMessage(socketMsg.message);
            break;
          case websocketTypes.CAMBIO_PRIORIDAD:
            handleCambioPrioridad();
            break;
          case websocketTypes.CAMBIOS_EN_OFERTA:
            const idAlumnoPrograma = localStorage.getItem("idAP");
            console.log("Chequeo si socket cambio oferta me corresponde...");
            if (idAlumnoPrograma && socketMsg.dataJson.alumnosProgramasIds?.includes(Number(idAlumnoPrograma))) {
              console.log("✅ Efectivamente el socket me incluye!");
              if (ofertaEnCurso.current) {
                cambiosIgnoradoContados.current = cambiosIgnoradoContados.current + 1;
                console.log(`--> ⛔ CAMBIO OFERTA Ignorado - contador: ${cambiosIgnoradoContados.current}`);
              } else {
                console.log("--> 🆗 CAMBIO OFERTA No ignorado");
                iniciarSolicitudOferta(socketMsg);
              }
            }
            break;
          case websocketTypes.CUPOS_RELOAD:
            updateCupos();
            break;
          case websocketTypes.CARREAS_RELOAD:
            reloadCarrerasInfo.current = true;
            break;
          case websocketTypes.CUPOS_VALUE:
            dispatch(updateCuposValue(socketMsg.dataJson));
            break;
          case websocketTypes.CUPO_VALUES_COMPLETE:
            handleCupoValuesComplete(socketMsg);
            break;
          case websocketTypes.ACTUALIZACION_OFERTA_KV:
            dispatch(clearPanelSubjectsDataList()); // limpiar panel de datos de cursos - catalogo y condicion de aprobacion
            handleRegenerarOfertaEInscripciones(true, socketMsg);
            break;
          case websocketTypes.ACTUALIZACION_INSCRIPCION_KV:
            handleRegenerarOfertaEInscripciones(false, socketMsg);
            break;
          case websocketTypes.ACTUALIZACION_DE_CUPO:
            handleCupoUpdateOptimized(socketMsg.dataJson);
            break;
          case websocketTypes.CAMBIO_SECCION_OFERTA_VALUE:
            handleUpdateCursoOferta(socketMsg);
            break;
          case websocketTypes.CURSOS_BORRADOS:
            const cursosBorrados = socketMsg.dataJson.cursosBorrados;
            if (cursosBorrados) {
              for (const cursoBorrado of cursosBorrados) {
                dispatch(
                  removeSeccionOferta({
                    id_materia: cursoBorrado.idMateria || 0,
                    id_curso: cursoBorrado.idCurso || 0,
                    anio_lectivo: cursoBorrado.anioLectivo || 0,
                  }),
                );
              }
            }
            break;
          case websocketTypes.LIMPIAR_CACHE_CATALOGO:
            handleLimpiarCacheCatalogo(socketMsg);
            break;
          default:
            break;
        }

        if (socketMsg.dataJson && socketMsg.type === websocketTypes.RESPUESTA_INSCRIPCION_ORACLE) {
          const { cursoId, anioLectivo } = socketMsg.dataJson;
          if (cursoId && anioLectivo && socketMsg.code === 200) {
            // INSCRIPCION ORACLE OK - Remover curso de la oferta
            dispatch(removeVisibleOfferedSubject({ idCurso: cursoId, anioLectivo: anioLectivo }));
          }
          dispatch(
            removeSubProcessSectionIds({
              idCurso: cursoId || 0,
              anioLectivo: anioLectivo || 0,
            }),
          );
          dispatch(
            removeSectionChangeInProcess({
              idCurso: cursoId || 0,
              anioLectivo: anioLectivo || 0,
            }),
          );
        }
        if (socketMsg.dataJson && socketMsg.type === websocketTypes.RESPUESTA_DESINSCRIPCION_ORACLE) {
          dispatch(
            removeFromInscribedSubjects({
              idCurso: socketMsg.dataJson.cursoId || 0,
              anioLectivo: socketMsg.dataJson.anioLectivo || 0,
            }),
          );
          dispatch(
            deleteUnsubProcessSectionId({
              idCurso: socketMsg.dataJson.cursoId || 0,
              anioLectivo: socketMsg.dataJson.anioLectivo || 0,
            }),
          );
        }
      }
    }
  }, [lastMessage]);

  return <></>;
}
